<template>
  <svg
    width="43"
    height="43"
    viewBox="0 0 43 43"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.92285 14.4629L38.2151 21.2727"
      stroke="var(--primary-blue)"
      stroke-width="5"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M8.38083 12.5332L7.14502 17.7259"
      stroke="var(--primary-blue)"
      stroke-width="5"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M3.15356 25.375L30.4503 39.3416C32.3628 40.3137 34.691 39.852 36.0903 38.2234L37.7963 36.2392"
      stroke="var(--primary-blue)"
      stroke-width="5"
      stroke-miterlimit="10"
      stroke-linecap="round"
    />
    <path
      d="M36.3597 9.71434C38.4485 9.71434 40.1417 8.02109 40.1417 5.93236C40.1417 3.84364 38.4485 2.15039 36.3597 2.15039C34.271 2.15039 32.5778 3.84364 32.5778 5.93236C32.5778 8.02109 34.271 9.71434 36.3597 9.71434Z"
      fill="var(--primary-blue)"
    />
    <path
      d="M31.5372 10.939C30.6626 8.87457 28.2799 7.91116 26.2154 8.78569L18.5569 12.0315C16.6157 12.8544 15.6494 15.0106 16.2688 16.9804C16.3376 17.2672 16.458 17.5424 16.63 17.7976C16.7992 18.093 17.0028 18.3625 17.2322 18.5976L21.9976 24.8512L16.0078 27.2483C14.7147 27.7644 14.0868 29.2324 14.6057 30.5227C14.9986 31.5091 15.9448 32.1083 16.9455 32.1083C17.258 32.1083 17.5734 32.051 17.8802 31.9277L27.0126 28.2748C27.7523 27.9794 28.3086 27.3515 28.5122 26.5802C28.7157 25.8117 28.5437 24.9888 28.0477 24.3666L23.6664 18.6836L29.3867 16.2579C31.4511 15.3834 32.4146 13.0006 31.54 10.9362L31.5372 10.939Z"
      fill="var(--primary-blue)"
    />
  </svg>
</template>
